import {
  ERROR_ACTION,
  SET_CAPTCHA_IMAGE,
  SET_DEPARTMENTS,
  SET_GET_OTP_RESPONSE,
  SET_VERIFY_OTP_FLAG_EMAIL,
  SET_VERIFY_OTP_FLAG_MOBILE,
  SET_OTP_VERIFICATION_EMAIL_STATUS,
  SET_OTP_VERIFICATION_MOBILE_STATUS,
  SET_BOTH_OTP_VERIFICATION,
  SET_GET_EMAIL_OTP_RESPONSE,
  SET_GET_MOBILE_OTP_RESPONSE,
  SET_VERIFY_OTP_FLAG_FORGOT_PASSWORD,
  SHOW_LOADER,
  HIDE_LOADER,
  SET_VERIFY_OTP_FLAG_REGISTRATION_EMAIL,
  SET_VERIFY_OTP_FLAG_REGISTRATION_MOBILE,
  SET_VERIFY_OTP_FLAG_LOGIN,
  SET_USER_NAME_FOR_LOGIN,
  GET_OTP_TIMER,
  GET_OTP_TIMER_MOBILE,
  GET_OTP_TIMER_EMAIL,
  SET_ALL_UPLOADED_DOCUMENTS,
  SET_MASTER_TYPES,
  SET_ALL_TYPES,
  SET_ALL_USER_ROLES,
  SET_ALL_USERS_BY_ROLE_ID_FROM,
  SET_ALL_USERS_BY_ROLE_ID_TO,
  SET_ALL_MODULES,
  SET_ALL_SUB_MODULES_BY_MODULE_ID,
  SET_ASSIGN_SUBMODULES_BY_USER_MODULE_ID,
  SET_TRANSACTIONAL_DATA_TYPES,
  SET_YEAR,
  SET_YEAR_BY_ID,
  SET_ALPHABETICAL_LIST,
  GET_QUALIFIED_CANDIDATE,
  GET_FLAG_ACCESS_STATUS,
  GET_QUALIFICATIONTYPE,
  GET_QUALIFICATION_NAME_BYTYPE,
  GET_DESIGNATION,
  GET_JOB_NATURE,
  GET_APPOINTMENT_NATURE,
  SET_MAINS_ADVERTISEMENT,
  SET_PRE_ADVERTISEMENT,
  GET_INTERVIEW_CRITERIA_DATA_VIEW,
  SET_USER_DEPT_ROLES,
  SET_USER_DEPT_ROLES_FROM,
  GET_RECOMMENDATION_CRITERIA_DATA_VIEW,
  SET_MODULE_SUBMODULE,
  SET_UPDATE_USER_DATA_ID,
  SET_FILE_UPLOAD_STATUS,
  SAVE_RESULT_FLOW_REQUEST,
  SAVE_RESULT_FLOW_SUCCESS,
  SAVE_RESULT_FLOW_FAILURE,
  SET_POST_CRITERIA_LIST,
  SET_SUBJECT_LIST_POST,
  SET_RESULT_FLOW_INFO,
  SET_LOOKUP_OPTIONS_EXAM_TYPE,
  SET_CHECK_QUALIFIED_LIST,
  SET_FINAL_RESULT_LIST,
  SET_CUTOFF_SUMMARY,
  SET_ADVERTISEMENT_RESULT_FLOW,
  SET_YEARS_FROM_EXAM_FLOW,
  SET_RESULT_FLOW_YEAR_LIST,
  SET_RESULT_FLOW_ADVERTISEMENT_LIST,
  SET_PROCESS_LOCK_STATE,
  GET_EXAM_NAME,
  GET_POST_CRITERIA_LIST,
} from "../../common/constants/ActionTypes";

const initialState = {
  errorMessage: "",
  captchaId: 0,
  loading: false,
  allDepartments: [],
  loginOTPSResponse: [],
  verifyEmailOtpFlag: true,
  otpVerificationStatusEmail: false,
  otpVerificationStatusMobile: false,
  bothOtpVerificationStatus: false,
  verifyMobileOtpFlag: true,
  emailOTPResponse: {
    id: "",
    type: "",
  },
  mobileOTPResponse: {
    id: "",
    type: "",
  },
  verifyOTPFlag: false,
  verifyOTPFlagForgotPassword: false,
  verifyOTPFlagRegistrationEmail: false,
  verifyOTPFlagRegistrationMobile: false,
  loginUserName: "",
  otpData: [],
  otpDataEmail: [],
  otpDataMobile: [],
  allAdverisementList: [],
  allUploadedDocuments: [],
  masterTypesList: [],
  allTypesList: [],
  userRolesList: [],
  userListByRoleIdFrom: [],
  userListByRoleIdTo: [],
  allModulesList: [],
  allSubModulesList: [],
  allAssignedSubModulesList: [],
  transactionalDataTypes: [],
  yearList: [],
  allYearList: [],
  getAccessStatus: [],
  getqualificationtype: [],
  getqualificationName: [],
  getMainsAdvertisement: [],
  getPreAdvertisement: [],
  getUserDeptRoles: [],
  getUserDeptRolesFrom: [],
  fileUploadStatus: [],
  loading: false,
  success: false,
  data: null,
  error: null,
  postCriteriaList: [],
  subjectListPost: [],
  resultFlowInfo: [],
  lookupOptionsExamType: [],
  checkQualifiedList: [],
  qualifyingCandidatesList: [],
  finalResultData: {},
  cutoffSummary: [],
  // advertisementResultFlow: [],
  // yearsFromExamFlow: [],
  resultFlowYearList: [],
  resultFlowAdvertisementList: [],
  examName: "",
  processLockState: {
    absent: false,
    duplicate: false,
    outOfRange: false,
    versionMismatch: false,
    result: false,
    seatMatrix: false

  },
  postCriteria: [],
};

export default function commonReducer(state = initialState, action) {
  switch (action.type) {
    case ERROR_ACTION:
      return {
        ...state,
        errorMessage: action.payload,
      };
    case SET_CAPTCHA_IMAGE:
      return {
        ...state,
        captchaId: action.payload,
      };
    case SET_DEPARTMENTS:
      return {
        ...state,
        allDepartments: action.payload,
      };
    case SET_GET_OTP_RESPONSE:
      return {
        ...state,
        loginOTPSResponse: action.payload,
      };
    case SET_VERIFY_OTP_FLAG_EMAIL:
      return {
        ...state,
        verifyEmailOtpFlag: action.payload,
      };
    case SET_VERIFY_OTP_FLAG_MOBILE:
      return {
        ...state,
        verifyMobileOtpFlag: action.payload,
      };
    case SET_OTP_VERIFICATION_EMAIL_STATUS:
      return {
        ...state,
        otpVerificationStatusEmail: action.payload,
      };
    case SET_OTP_VERIFICATION_MOBILE_STATUS:
      return {
        ...state,
        otpVerificationStatusMobile: action.payload,
      };
    case SET_BOTH_OTP_VERIFICATION:
      return {
        ...state,
        bothOtpVerificationStatus: action.payload,
      };
    case SET_GET_EMAIL_OTP_RESPONSE:
      return {
        ...state,
        emailOTPResponse: action.payload,
      };
    case SET_GET_MOBILE_OTP_RESPONSE:
      return {
        ...state,
        mobileOTPResponse: action.payload,
      };
    case SET_VERIFY_OTP_FLAG_FORGOT_PASSWORD:
      return {
        ...state,
        verifyOTPFlagForgotPassword: action.payload,
      };
    case SHOW_LOADER:
      return {
        ...state,
        loading: true,
      };
    case HIDE_LOADER:
      return {
        ...state,
        loading: false,
      };
    case SET_VERIFY_OTP_FLAG_REGISTRATION_EMAIL:
      return {
        ...state,
        verifyOTPFlagRegistrationEmail: action.payload,
      };
    case SET_VERIFY_OTP_FLAG_REGISTRATION_MOBILE:
      return {
        ...state,
        verifyOTPFlagRegistrationMobile: action.payload,
      };
    case SET_VERIFY_OTP_FLAG_LOGIN:
      return {
        ...state,
        verifyOTPFlag: action.payload,
      };
    case SET_USER_NAME_FOR_LOGIN:
      return {
        ...state,
        loginUserName: action.payload,
      };
    case GET_OTP_TIMER:
      return {
        ...state,
        otpData: action.payload,
      };
    case GET_OTP_TIMER_EMAIL:
      return {
        ...state,
        otpDataEmail: action.payload,
      };
    case GET_OTP_TIMER_MOBILE:
      return {
        ...state,
        otpDataMobile: action.payload,
      };
    case SET_ALL_UPLOADED_DOCUMENTS:
      return {
        ...state,
        allUploadedDocuments: action.payload,
      };
    case SET_MASTER_TYPES:
      return {
        ...state,
        masterTypesList: action.payload,
      };
    case SET_TRANSACTIONAL_DATA_TYPES:
      return {
        ...state,
        transactionalDataTypes: action.payload,
      };
    case SET_ALL_TYPES:
      return {
        ...state,
        allTypesList: action.payload,
      };
    case SET_ALL_USER_ROLES:
      return {
        ...state,
        userRolesList: action.payload,
      };
    case SET_ALL_USERS_BY_ROLE_ID_FROM:
      return {
        ...state,
        userListByRoleIdFrom: action.payload,
      };
    case SET_ALL_USERS_BY_ROLE_ID_TO:
      return {
        ...state,
        userListByRoleIdTo: action.payload,
      };
    case SET_ALL_MODULES:
      return {
        ...state,
        allModulesList: action.payload,
      };
    case SET_ALL_SUB_MODULES_BY_MODULE_ID:
      return {
        ...state,
        allSubModulesList: action.payload,
      };
    case SET_ASSIGN_SUBMODULES_BY_USER_MODULE_ID:
      return {
        ...state,
        allAssignedSubModulesList: action.payload,
      };
    case SET_YEAR:
      return {
        ...state,
        yearList: action.payload,
      };

    case SET_YEAR_BY_ID: {
      return {
        ...state,
        allYearList: action.payload,
      };
    }
    case SET_ALPHABETICAL_LIST:
      return {
        ...state,
        alphabeticallist: action.payload,
      };
    case GET_QUALIFIED_CANDIDATE:
      return {
        ...state,
        qualifiedCandidate: action.payload,
      };
    case GET_FLAG_ACCESS_STATUS:
      return {
        ...state,
        getAccessStatus: action.payload,
      };
    case GET_QUALIFICATIONTYPE: {
      return {
        ...state,
        getqualificationtype: action.payload,
      };
    }
    case GET_QUALIFICATION_NAME_BYTYPE: {
      return {
        ...state,
        getqualificationName: action.payload,
      };
    }
    case GET_DESIGNATION: {
      return { ...state, getDesignation: action.payload };
    }
    case GET_JOB_NATURE: {
      return {
        ...state,
        getjobnature: action.payload,
      };
    }
    case GET_APPOINTMENT_NATURE: {
      return {
        ...state,
        getappointmentNature: action.payload,
      };
    }
    case SET_MAINS_ADVERTISEMENT: {
      return {
        ...state,
        getMainsAdvertisement: action.payload,
      };
    }
    case SET_PRE_ADVERTISEMENT: {
      return {
        ...state,
        getPreAdvertisement: action.payload,
      };
    }
    case SET_USER_DEPT_ROLES: {
      return {
        ...state,
        getUserDeptRoles: action.payload,
      };
    }
    case SET_USER_DEPT_ROLES_FROM: {
      return {
        ...state,
        getUserDeptRolesFrom: action.payload,
      };
    }
    case GET_INTERVIEW_CRITERIA_DATA_VIEW: {
      return {
        ...state,
        getInterviewCriteriaData: action.payload,
      };
    }
    case GET_RECOMMENDATION_CRITERIA_DATA_VIEW: {
      return {
        ...state,
        getRecommendationCriteriaData: action.payload,
      };
    }
    case SET_MODULE_SUBMODULE: {
      return {
        ...state,
        getModuleSubmodule: action.payload
      }
    }
    case SET_UPDATE_USER_DATA_ID: {
      return {
        ...state,
        getUpdateUserData: action.payload
      }
    }
    case SET_FILE_UPLOAD_STATUS: {
      return {
        ...state,
        fileUploadStatus: action.payload
      }
    }
    case SAVE_RESULT_FLOW_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };

    case SAVE_RESULT_FLOW_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        data: action.payload,
      };

    case SAVE_RESULT_FLOW_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };

    case SET_POST_CRITERIA_LIST:
      return {
        ...state,
        postCriteriaList: action.payload,
      };

    case SET_SUBJECT_LIST_POST:
      return {
        ...state,
        subjectListPost: action.payload,
      };

    case SET_RESULT_FLOW_INFO:
      return {
        ...state,
        resultFlowInfo: action.payload,
      };
    case SET_LOOKUP_OPTIONS_EXAM_TYPE:
      return {
        ...state,
        lookupOptionsExamType: action.payload,
      };
    case SET_CHECK_QUALIFIED_LIST:
      return {
        ...state,
        checkQualifiedList: action.payload,
      };
    case SET_FINAL_RESULT_LIST:
      return {
        ...state,
        finalResultData: action.payload,
      };

    case SET_CUTOFF_SUMMARY:
      return {
        ...state,
        cutoffSummary: action.payload,
      };
    // case SET_ADVERTISEMENT_RESULT_FLOW:
    //   return {
    //     ...state,
    //     advertisementResultFlow: action.payload,
    //   };
    // case SET_YEARS_FROM_EXAM_FLOW:
    //   return {
    //     ...state,
    //     yearsFromExamFlow: action.payload,
    //   };

    // case SET_RESULT_FLOW_YEAR_LIST:
    //   return {
    //     ...state,
    //     resultFlowYearList: action.payload,
    //   };

    // case SET_RESULT_FLOW_ADVERTISEMENT_LIST:
    //   return {
    //     ...state,
    //     resultFlowAdvertisementList: action.payload,
    //   };

    case SET_RESULT_FLOW_YEAR_LIST:
      return {
        ...state,
        resultFlowYearList: action.payload,
      };

    case SET_RESULT_FLOW_ADVERTISEMENT_LIST:
      return {
        ...state,
        resultFlowAdvertisementList: action.payload,
      };
    case SET_PROCESS_LOCK_STATE:
      return {
        ...state,
        processLockState: action.payload
      };
    case GET_EXAM_NAME:
      return {
        ...state,
        examName: action.payload,
      };

    case GET_POST_CRITERIA_LIST:
      return {
        ...state,
        postCriteria: action.payload
      };

    default:
      return state;
  }
}
